<template>
  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow': visible }"
    :style="visible ? 'display:block;' : ''"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center mt-4">
          <span
            v-if="success"
            class="material-icons text-treid"
            style="font-size: 77px"
          >
            thumb_up
          </span>
          <span
            v-else
            class="material-icons text-danger"
            style="font-size: 77px"
          >
            sentiment_dissatisfied
          </span>
          <h5 class="modal-title">{{ title }}</h5>
          <div v-html="body"></div>
        </div>
        <div class="p-3 text-center">
          <span
            v-if="this.return"
            class="btn btn-treid"
            @click="handleClilickReturn"
            >Volver</span
          >
          <span v-if="acept" class="btn btn-treid" @click="handleClilickSend"
            >Aceptar</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModalNotify",
  props: {
    visible: Boolean,
    success: Boolean,
    title: String,
    body: String,
    return: Boolean,
    acept: Boolean,
  },
  methods: {
    handleClilickReturn() {
      this.$emit("clickReturn");
    },
    handleClilickSend() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="css" scoped>
</style>